import {Button, Toolbar, ToolbarItem} from "@progress/kendo-react-buttons"
import {DatePicker, DatePickerChangeEvent} from "@progress/kendo-react-dateinputs"
import {Field, FieldRenderProps, Form, FormElement, FormRenderProps} from "@progress/kendo-react-form"
import {Input, NumericTextBox, Switch} from "@progress/kendo-react-inputs"
import dayjs from "dayjs"
import {
    MDBBtn,
    MDBCol,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog,
    MDBModalHeader,
    MDBModalTitle,
    MDBRow,
} from "mdbreact"
import {useEffect, useRef, useState} from "react"
import {setToastr} from "../../containers/App/appSlice"
import {
    addDvsaFeeById,
    toggleDVSAModalAddEdit,
    DvsaFeeDefault,
    editDvsaFeeExpection,
    dvsaDefaultInit,
    setSelectedExpetion,
} from "../../containers/DvsaFees/dvsaFeesSlice"
import {RootState} from "../../rootReducer"
import {SpinnerFragment} from "../../shared/CommonItems"
import {useAppDispatch, useAppSelector} from "../../store"
import {PermissionsChecker} from "../Shared/permissionChecker"

const AddEditDVSAFee = () => {
    const dispatch = useAppDispatch()
    const isDvsaModal = useAppSelector((state: RootState) => state.containers.dvsaFees.dvsaModalAddEdit)
    const selectedDVSAdefault = useAppSelector((state: RootState) => state.containers.dvsaFees.selectedDVSAdefault)
    const selectedDvsaId = useAppSelector((state: RootState) => state.containers.dvsaFees.selectedDvsaID)
    const dvsaFeeLoader = useAppSelector((state: RootState) => state.containers.dvsaFees.dvsaFeeLoader)
    const formRef = useRef<any>()

    const [dvsaFeeInit, setDVSAFeeInit] = useState<DvsaFeeDefault>(selectedDVSAdefault)
    const dvsaDate = selectedDVSAdefault.effectiveDate

    useEffect(() => {
        setDVSAFeeInit(selectedDVSAdefault)
    }, [selectedDVSAdefault])

    const handleSubmit = (e: any) => {
        let dvsaFeeData = {...e, effectiveDate: dayjs(e.effectiveDate).format("YYYY-MM-DD")}
        const errorToastr = (message: string) => {
            dispatch(
                setToastr({
                    isActive: true,
                    message: message,
                    delay: 3000,
                    title: "Error",
                    type: "danger",
                    description: "",
                }),
            )
        }
        if (dvsaFeeData.dayFee === 0) errorToastr("Dayfee should be greater than 0")
        else if (dvsaFeeData.dayFee > 9999999) errorToastr("Dayfee should be less than 9,999,999")
        else if (
            dvsaFeeData.effectiveDate === "Invalid Date" ||
            dayjs(dvsaFeeData.effectiveDate).isValid() === false ||
            dvsaFeeData.effectiveDate < dayjs(new Date()).format("YYYY-MM-DD")
        )
            errorToastr("Enter valid Date")
        else
            dvsaFeeData.dayFee > 0 &&
                dispatch(
                    e.dvsaFeeID === 0
                        ? addDvsaFeeById(selectedDvsaId, {
                              ...dvsaFeeData,
                          })
                        : editDvsaFeeExpection(selectedDvsaId, {...dvsaFeeData}),
                )
    }

    const ExceptionSwitch = (props: FieldRenderProps) => {
        let {name, value, onChange} = props
        value = value ? true : false

        return <Switch name={name} checked={value} onChange={onChange} value={value} />
    }

    useEffect(() => {
        isDvsaModal && formRef.current?.resetForm()
    }, [isDvsaModal])

    const DateComponent = (fieldRenderProps: FieldRenderProps) => {
        const {required, value, label, min, onChange} = fieldRenderProps
        const updateOnEndDate = (event: DatePickerChangeEvent) => onChange(event)

        return (
            <DatePicker
                label={label}
                value={value}
                width="265px"
                onChange={updateOnEndDate}
                min={min}
                required={required}
            />
        )
    }

    return (
        <MDBModal className="lvl-two-popup" staticBackdrop animationDirection="right" show={isDvsaModal} tabIndex="-1">
            <MDBModalDialog position="top right modal-sm" side>
                <MDBModalContent className="full-height">
                    <MDBModalHeader titleClass="lead">
                        <MDBModalTitle>DVSA Fee</MDBModalTitle>
                        <MDBBtn
                            color="none"
                            className="btn-close"
                            onClick={() => {
                                dispatch(toggleDVSAModalAddEdit(false))
                                dispatch(setSelectedExpetion(dvsaDefaultInit()))
                            }}
                        ></MDBBtn>
                    </MDBModalHeader>
                    {dvsaFeeLoader && <SpinnerFragment />}
                    <Form
                        key={JSON.stringify(dvsaFeeInit)}
                        initialValues={dvsaFeeInit}
                        onSubmit={handleSubmit}
                        ref={formRef}
                        ignoreModified
                        render={(formRenderProps: FormRenderProps) => (
                            <FormElement className="w-100">
                                <Toolbar className="shadow-0 border-bottom p-0 pb-1 pt-1  position-sticky top-0">
                                    <ToolbarItem>
                                        <PermissionsChecker permission={["DVSAFee.Edit"]}>
                                            <Button
                                                disabled={!formRenderProps.allowSubmit}
                                                type="submit"
                                                fillMode="flat"
                                                themeColor={"primary"}
                                                iconClass="fa fa-save"
                                                title="save"
                                                onClick={e => formRef.current && formRef.current.onSubmit(e)}
                                            >
                                                Save
                                            </Button>
                                        </PermissionsChecker>
                                    </ToolbarItem>
                                </Toolbar>

                                <MDBModalBody className="modal-overflow">
                                    <fieldset className={"k-form-fieldset mt-0"}>
                                        <Input name="dvsaFeeID" type={"hidden"} />
                                        <MDBRow>
                                            <MDBCol md="12">
                                                <Field
                                                    required
                                                    name={"effectiveDate"}
                                                    component={DateComponent}
                                                    min={dvsaDate ?? new Date()}
                                                    onChange={event =>
                                                        setDVSAFeeInit({
                                                            ...formRef.current.values,
                                                            effectiveDate: new Date(event.value),
                                                        })
                                                    }
                                                    label="Date"
                                                    tabIndex={1}
                                                />
                                            </MDBCol>
                                            <MDBCol md="12">
                                                <Field
                                                    required
                                                    tabIndex={2}
                                                    name={"dayFee"}
                                                    component={NumericTextBox}
                                                    format="c2"
                                                    label="Fee"
                                                    min={0}
                                                />
                                            </MDBCol>
                                            <MDBCol>
                                                <span className="m-1 pe-3 small">Exception</span>
                                                <Field
                                                    name="isException"
                                                    component={ExceptionSwitch}
                                                    label="isException"
                                                    value={dvsaFeeInit.isException}
                                                />
                                            </MDBCol>
                                        </MDBRow>
                                    </fieldset>
                                </MDBModalBody>
                            </FormElement>
                        )}
                    />
                </MDBModalContent>
            </MDBModalDialog>
        </MDBModal>
    )
}

export default AddEditDVSAFee
